module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraBoldItalic.29f7dd01.ttf";